import React, { memo } from "react";
import wrapperHOC from "@Utils/wrapperHOC";
import config from "config/index";
import getImagePath from "@Utils/getImagePath";
import Image from "@Components/Image";
import CustomLink from "@Components/CustomLink";
import {
  INSTAGRAM_URL,
  YOUTUBE_URL,
  TIKTOK_URL,
  LINKEDIN_URL,
  FACEBOOK_URL,
  TWITTER_URL,
  PINTEREST_URL,
} from "constants/configConstants";
import useTranslationHook from "hooks/useTranslationHook";
import styles from "./SocialIcons.module.scss";

const SocialIcons: React.FC = () => {
  const { t } = useTranslationHook();
  return (
    <div className={styles.socialSection}>
      <p className={styles.socialLabel}>{t("mischlaneous.follow_us_on")}</p>
      <div className={styles.socialIcons}>
        <CustomLink href={INSTAGRAM_URL} target="_blank" rel="noreferrer" isExternal>
          <Image
            src={getImagePath(`${config.IMAGE_STATIC_URL}/images/Instagram.svg`)}
            alt="Instagram"
            width="20px"
            height="20px"
          />
        </CustomLink>
        <CustomLink href={YOUTUBE_URL} target="_blank" rel="noreferrer" isExternal>
          <Image
            src={getImagePath(`${config.IMAGE_STATIC_URL}/images/Youtube.svg`)}
            alt="YouTube"
            width="20px"
            height="20px"
          />
        </CustomLink>
        <CustomLink href={TIKTOK_URL} target="_blank" rel="noreferrer" isExternal>
          <Image
            src={getImagePath(`${config.IMAGE_STATIC_URL}/images/tiktok.svg`)}
            alt="TikTok"
            width="20px"
            height="20px"
          />
        </CustomLink>
        <CustomLink href={LINKEDIN_URL} target="_blank" rel="noreferrer" isExternal>
          <Image
            src={getImagePath(`${config.IMAGE_STATIC_URL}/images/Linkedin.svg`)}
            alt="LinkedIn"
            width="20px"
            height="20px"
          />
        </CustomLink>
        <CustomLink href={FACEBOOK_URL} target="_blank" rel="noreferrer" isExternal>
          <Image
            src={getImagePath(`${config.IMAGE_STATIC_URL}/images/Facebook.svg`)}
            alt="Facebook"
            width="20px"
            height="20px"
          />
        </CustomLink>
        <CustomLink href={TWITTER_URL} target="_blank" rel="noreferrer" isExternal>
          <Image
            src={getImagePath(`${config.IMAGE_STATIC_URL}/images/Twitter.svg`)}
            alt="Twitter"
            width="20px"
            height="20px"
          />
        </CustomLink>
        <CustomLink href={PINTEREST_URL} target="_blank" rel="noreferrer" isExternal>
          <Image
            src={getImagePath(`${config.IMAGE_STATIC_URL}/images/pinterest.svg`)}
            alt="Pinterest"
            width="20px"
            height="20px"
          />
        </CustomLink>
      </div>
    </div>
  );
};

export default wrapperHOC(memo(SocialIcons), {
  componentName: "SocialIcons-Blog",
  showForChina: true,
});
